import styled from '@emotion/styled'

export interface CardProps {
  elevation?: 1 | 2 | 3 | 4
  padding?: 'none' | 'sm' | 'md' | 'lg'
}

const elevationToken = (n: NonNullable<CardProps['elevation']>) => `var(--e-${n})`
const paddingToken = (p: NonNullable<CardProps['padding']>) =>
  p === 'none'
    ? '0'
    : p === 'sm'
      ? 'var(--s-4)'
      : p === 'lg'
        ? 'var(--s-8)'
        : 'var(--s-6)'

export const Card = styled.div<CardProps>`
  background: var(--c-bg-elev);
  border: 1px solid var(--c-border);
  border-radius: var(--r-lg);
  box-shadow: ${({ elevation = 2 }) => elevationToken(elevation)};
  padding: ${({ padding = 'md' }) => paddingToken(padding)};
`
